<template>
    <div class="pageBox">
        <Header ref="Header" current='souye'></Header>
        <div class="pageBox_cen">
            <template v-for="(item, index) in list">
                <component :is="mapComponent[item.name]" :showMore="false" :dataInfo="item.data" :list='item' :ref="item.name"
                    @goScroll='goScroll' />
            </template>
        </div>
        <Footer></Footer>
    </div>
</template>

<script>
import Header from "@/components/header.vue"
import Footer from "@/components/footer.vue"
import mapComponent from "@/components/mapComponent.js";
import { get_tj_list } from '@/api/cases.js'
export default {
    components: {
        Header,
        Footer,
    },
    data() {
        return {
            mapComponent,
            list: [{
                name: 'clinicalCases',
                value: '病例推荐',
                data: {
                    is_show: 1,
                    list: [],
                    moduleTitle: this.$t('i18n_65'),
                },
            },
            {
                name: 'animallList',
                value: '病例列表',
                data: {},
            }],
            navHidden: false, // 导航栏是否隐藏
            lastScrollTop: 0, // 上一次页面滚动的位置
            currentRoute: '',
        }
    },
    created() {
        this.getRecommendData()
    },
    mounted() {
        window.addEventListener('scroll', this.handleScroll);
        this.currentRoute = this.$route.path; // 初始化时获取当前路由地址
        this.$watch('$route', this.onRouteChange);
        var element;
        if (this.nowVibe == 'pc') {
            element = document.documentElement
        } else {
            element = document.documentElement.scrollTop ? document.documentElement : document.body;
        }
        let scrollTop = element.scrollTop;
        if (scrollTop == 0) {
            if (!this.$refs.Header.navHead) {
                this.$refs.Header.headerHover = false;
            }
            this.$refs.Header.headerTrue = false;
        } else {
            this.$refs.Header.headerTrue = true;
            this.$refs.Header.headerHover = true;
        }
    },
    beforeDestroy() {
        window.removeEventListener('scroll', this.handleScroll);

    },
    methods: {
        onRouteChange(newRoute, oldRoute) {
            this.currentRoute = newRoute.path; // 更新当前路由地址
            this.$refs.productCen[0].querValue = this.$route.query.value;
            // this.goScroll(this.$route.query.value)
        },
        handleScroll() {
            const currentScrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body
                .scrollTop || 0;
            if (currentScrollTop > this.lastScrollTop) {
                this.navHidden = true;
            } else {
                this.navHidden = false;
            }
            this.lastScrollTop = currentScrollTop;

            // this.$refs.productCen[0].navHidden = this.navHidden;
            if (currentScrollTop == 0) {
                if (!this.$refs.Header.navHead) {
                    this.$refs.Header.headerHover = false;
                } else {
                    this.$refs.Header.mouseoverLi(3);
                }
                this.$refs.Header.headerTrue = false;
            } else {
                this.$refs.Header.headerTrue = true;
                this.$refs.Header.headerHover = true;
            }
        },
        goScroll(e) {
            this.lastScrollTop = e;
            // document.documentElement.scrollTop = e+10;
            var element;
            if (this.nowVibe == 'pc') {
                element = document.documentElement
            } else {
                element = document.documentElement.scrollTop ? document.documentElement : document.body;
            }
            element.scrollTop = e + 10;
            // document.documentElement.scrollTop=0
        },
        //获取推荐数据
        getRecommendData() {
            get_tj_list({}).then(res => {
                this.list[0].data.list = res.data
            })
        },
    },
}
</script>

<style></style>
<style scoped lang="scss">
.pageBox {
    display: flex;
    flex-direction: column;
    min-height: 100vh;

    .pageBox_cen {
        flex: 1;
    }
}
</style>